module.exports = __webpack_public_path__ + "media/theme/blog_border-1-5e302898.png";